/* eslint-disable */


// Programatically generated on Wed Nov 26 2025 21:02:12 GMT+0000
import {fromJS, List, Map, Record, Set} from 'immutable';
import {GenericModel} from 'resources/Generic.model';
import {validate, Empty} from '@albert-io/json-api-framework/models/helpers';
import moment from 'moment';

const ModelConfig = fromJS(
  {
    'endpoint': 'public_questions_v1',
    'attributes': {
      'difficulty': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'title': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'slug_id': {
        'type': 'string',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'position': {
        'type': 'integer',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'updated_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'inserted_at': {
        'type': 'datetime',
        'isRequired': false,
        'isReadOnly': true,
        'isWriteOnly': false
      },
      'id': {
        'type': 'binary_id',
        'isRequired': false,
        'isReadOnly': false,
        'isWriteOnly': false
      }
    },
    'relationships': {
      'authoring_guide_levels_v1': {
        'type': 'one-to-many'
      },
      'tags_v1': {
        'type': 'one-to-many'
      },
      'user_feedback_v1': {
        'type': 'one-to-many'
      },
      'standards_v1': {
        'type': 'one-to-many'
      },
      'guide_levels_v1': {
        'type': 'one-to-many'
      },
      'authoring_question_set_v1': {
        'type': 'one-to-one'
      },
      'guide_levels_v2': {
        'type': 'one-to-many'
      },
      'search_tags_v1': {
        'type': 'one-to-many'
      },
      'question_set_v1': {
        'type': 'one-to-one'
      },
      'draft_guesses_v1': {
        'type': 'one-to-many'
      },
      'authoring_labels_v1': {
        'type': 'one-to-many'
      },
      'guesses_v1': {
        'type': 'one-to-many'
      },
      'labels_v1': {
        'type': 'one-to-many'
      },
      'search_standards_v1': {
        'type': 'one-to-many'
      },
      'search_standards_v2': {
        'type': 'one-to-many'
      }
    }
  }
);

const ModelRecord = Record(
  {
    'guesses': Empty,
    'draft_guesses': Empty,
    'authoring_labels': Empty,
    'question_set': Empty,
    'position': Empty,
    'slug_id': Empty,
    'search_tags': Empty,
    'authoring_question_set': Empty,
    'guide_levels': Empty,
    'standards': Empty,
    'updated_at': Empty,
    'title': Empty,
    'tags': Empty,
    'user_feedback': Empty,
    'inserted_at': Empty,
    'authoring_guide_levels': Empty,
    'id': Empty,
    'difficulty': Empty,
    'relationshipMeta': Empty,
    'search_standards': Empty,
    'labels': Empty,
    'meta': new Map({
    'populated_metadata_fields': Empty
  })
  }
);

const DefaultModel = fromJS(
  {
    'slug_id': '',
    'title': '',
    'id': '',
    'updated_at': new Date(),
    'inserted_at': new Date(),
    'guesses': new List(),
    'draft_guesses': new List(),
    'authoring_labels': new List(),
    'search_tags': new List(),
    'standards': new List(),
    'search_standards': new List(),
    'meta': new Map(),
    'question_set': new Map(),
    'position': 0,
    'guide_levels': new List(),
    'tags': new List(),
    'user_feedback': new List(),
    'authoring_guide_levels': new List(),
    'authoring_question_set': new Map(),
    'difficulty': 0,
    'labels': new List(),
    'relationshipMeta': new Map()
  }
);

export class PublicQuestionModelV1 extends GenericModel(ModelRecord, ModelConfig, 'PublicQuestionModelV1') {
  // -- Query Rules --
  /**
   * @returns {boolean}
   */
  static allowsInclude(include) {
    // AllowedIncludes is currently disabled.
    return true; // AllowedIncludes.has(include);
  }

  /**
   * @returns {boolean}
   */
  static allowsFilter(filterField, filterType) {
    return filterType ?
      FilterRules.get(filterField).has(filterType) :
      FilterRules.has(filterField);
  }

  /**
   * @returns {boolean}
   */
  static allowsSort(sort) {
    return sort.split(',').filter((s) => AllowedSorts.has(s)).length > 0;
  }

  /**
   * @returns {Array}
   */
  static getAllowedSorts() {
    return AllowedSorts.keySeq().toJS();
  }

  static getMetaContextQuery(key) {
    if (!MetadataContextRules.hasIn(['optional', key]) && !MetadataContextRules.hasIn(['required', key])) {
      console.error('Rule for meta context key ' + key + ' does not exist');
    }

    return MetadataContextRules.getIn(['optional', key]) || MetadataContextRules.getIn(['required', key]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getRequiredMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values()]);
  }

  /**
   * @returns {Immutable.Set}
   */
  static getAllMetaContextRules() {
    return new Set([...MetadataContextRules.get('required').values(), ...MetadataContextRules.get('optional').values()]);
  }

  static getDefaultModel() {
    _emptyPublicQuestionModelV1Model = _emptyPublicQuestionModelV1Model ? _emptyPublicQuestionModelV1Model : new PublicQuestionModelV1(DefaultModel);
    return _emptyPublicQuestionModelV1Model;
  }

  static supportsMetaContext() {
    return MetadataContextRules !== null;
  }

  /**
   * @returns {string}
   */
  static getModelName() {
    return 'PublicQuestionModelV1';
  }

  /**
   * @returns {boolean}
   */
  static _isFullSpec() {
    return true;
  }

  constructor() {
    super(...arguments);
    this.__meta = null;
  }

  /**
   * @returns {string}
   */
  getJsonApiType() {
    return 'public_question_v1';
  }

  /**
   * @params {string} - An attribute name
   * @params {*} [def] - Optional default value override for the attribute
   */
  getValueForAttribute(attribute, def) {
    let value = this.get(attribute);
    validate(value, attribute);
    if (value === Empty) {
      value = def !== undefined ? def : DefaultModel.get(attribute);
    }
    return value;
  }

  // -- Primary Attributes --
  
  /**
   * @type {integer}
   */
  getDifficulty() {
    const value = this.getValueForAttribute('difficulty');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  /**
   * @type {binary_id}
   */
  getId() {
    const value = this.getValueForAttribute('id');
    return value;
  }

  setId(value) {
    return this.setField('id', value);
  }

  /**
   * @type {datetime}
   */
  getInsertedAt() {
    const value = this.getValueForAttribute('inserted_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  /**
   * @type {integer}
   */
  getPosition() {
    const value = this.getValueForAttribute('position');
    
      const int = parseInt(value, 10);
      return isNaN(int) ? value : int;
    
  }

  /**
   * @type {string}
   */
  getSlugId() {
    const value = this.getValueForAttribute('slug_id');
    return value;
  }

  /**
   * @type {string}
   */
  getTitle() {
    const value = this.getValueForAttribute('title');
    return value;
  }

  /**
   * @type {datetime}
   */
  getUpdatedAt() {
    const value = this.getValueForAttribute('updated_at');
    
      const momentValue = moment(value);
      return momentValue.isValid() ? momentValue : value;
    
  }

  // -- Meta Attributes --
  
    /**
     * LEGACY META ACCESSORS
     * @todo These should no longer be used, instead use this.getMeta()[...]
     */
    
      getPopulatedMetadataFields() {
        return this.getMeta().getPopulatedMetadataFields();
      }
    
    getMeta() {
      if (this.__meta) {
        return this.__meta;
      }
      const meta = this.get('meta', Map());
      this.__meta = {
        
          /**
           * @type {string[]}
           */
          getPopulatedMetadataFields() {
            const value = meta.get('populated_metadata_fields');
            validate(value, 'populated_metadata_fields');
            return value;
          },
  
      };
      return this.__meta;
    }
  
  // -- Relationships --
  
  /**
   * @type {guess_v1 (many)}
   */
  getGuesses() {
    const value = this.getValueForAttribute('guesses');
    return value;
  }

  // -- Relationship Fields: guesses --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {draft_guess_v1 (many)}
   */
  getDraftGuesses() {
    const value = this.getValueForAttribute('draft_guesses');
    return value;
  }

  // -- Relationship Fields: draft_guesses --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {authoring_label_v1 (many)}
   */
  getAuthoringLabels() {
    const value = this.getValueForAttribute('authoring_labels');
    return value;
  }

  // -- Relationship Fields: authoring_labels --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {question_set_v1 (one)}
   */
  getQuestionSet() {
    const value = this.getValueForAttribute('question_set');
    return value;
  }

  // -- Relationship Fields: question_set --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {search_tag_v1 (many)}
   */
  getSearchTags() {
    const value = this.getValueForAttribute('search_tags');
    return value;
  }

  // -- Relationship Fields: search_tags --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {authoring_question_set_v1 (one)}
   */
  getAuthoringQuestionSet() {
    const value = this.getValueForAttribute('authoring_question_set');
    return value;
  }

  // -- Relationship Fields: authoring_question_set --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {guide_level_v2 (many)}
   */
  getGuideLevels() {
    const value = this.getValueForAttribute('guide_levels');
    return value;
  }

  // -- Relationship Fields: guide_levels --

  /**
   * Adds relationship field getters to the provided object.
   * @private
   */
  __withGuideLevelRelationshipGetters(data) {
    return {
      getPosition() {
        return data.get('position', null);
      }
    };
  }

  /**
   * @param {string} [id] - A single relationship to retrieve.
   * @returns {Immutable.List|Immutable.Map}
   */
  getGuideLevelRelationships(id) {
    const data = this.getIn(['relationshipMeta', 'guide_level'], new Map());
    if (!id) {
      return data.map((rel) => this.__withGuideLevelRelationshipGetters(rel));
    } else {
      return this.__withGuideLevelRelationshipGetters(data.get(id, new Map()));
    }
  }

  /**
   * @type {standard_v1 (many)}
   */
  getStandards() {
    const value = this.getValueForAttribute('standards');
    return value;
  }

  // -- Relationship Fields: standards --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {tag_v1 (many)}
   */
  getTags() {
    const value = this.getValueForAttribute('tags');
    return value;
  }

  // -- Relationship Fields: tags --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {user_feedback_v1 (many)}
   */
  getUserFeedback() {
    const value = this.getValueForAttribute('user_feedback');
    return value;
  }

  // -- Relationship Fields: user_feedback --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {authoring_guide_level_v1 (many)}
   */
  getAuthoringGuideLevels() {
    const value = this.getValueForAttribute('authoring_guide_levels');
    return value;
  }

  // -- Relationship Fields: authoring_guide_levels --

  /**
   * Adds relationship field getters to the provided object.
   * @private
   */
  __withAuthoringGuideLevelRelationshipGetters(data) {
    return {
      getPosition() {
        return data.get('position', null);
      }
    };
  }

  /**
   * @param {string} [id] - A single relationship to retrieve.
   * @returns {Immutable.List|Immutable.Map}
   */
  getAuthoringGuideLevelRelationships(id) {
    const data = this.getIn(['relationshipMeta', 'authoring_guide_level'], new Map());
    if (!id) {
      return data.map((rel) => this.__withAuthoringGuideLevelRelationshipGetters(rel));
    } else {
      return this.__withAuthoringGuideLevelRelationshipGetters(data.get(id, new Map()));
    }
  }

  /**
   * @type {search_standard_v2 (many)}
   */
  getSearchStandards() {
    const value = this.getValueForAttribute('search_standards');
    return value;
  }

  // -- Relationship Fields: search_standards --
  // no 'fields' found, skipped generating accessor(s)
  
  /**
   * @type {label_v1 (many)}
   */
  getLabels() {
    const value = this.getValueForAttribute('labels');
    return value;
  }

  // -- Relationship Fields: labels --
  // no 'fields' found, skipped generating accessor(s)
  
}

// -- Empty Model Instance --
let _emptyPublicQuestionModelV1Model = null;

// -- Sort Rules --

const AllowedSorts = fromJS({
  'difficulty': null,
  'id': null,
  'inserted_at': null,
  'position': null,
  'slug_id': null,
  'title': null,
  'updated_at': null,
});

// -- Include Rules --
// List []

// -- Filter Rules --
const FilterRules = new Map({
  'authoring_guide_levels_v1': new Set(['associated']),
  'authoring_labels_v1': new Set(['associated']),
  'authoring_question_set_v1': new Set(['associated']),
  'difficulty': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'draft_guesses_v1': new Set(['associated']),
  'guesses_v1': new Set(['associated']),
  'guide_levels_v1': new Set(['associated']),
  'guide_levels_v2': new Set(['associated']),
  'id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'inserted_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'labels_v1': new Set(['associated']),
  'meta.populated_metadata_fields': new Set(['null']),
  'position': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'question_set_v1': new Set(['associated']),
  'search_standards_v1': new Set(['associated']),
  'search_standards_v2': new Set(['associated']),
  'search_tags_v1': new Set(['associated']),
  'slug_id': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'standards_v1': new Set(['associated']),
  'tags_v1': new Set(['associated']),
  'title': new Set(['exact','substring','case_insensitive_substring','not','null','case_insensitive_prefix','search_keyword']),
  'updated_at': new Set(['exact','greater_than','less_than','less_than_inclusive','greater_than_inclusive','not','null']),
  'user_feedback_v1': new Set(['associated']),
});
    

// -- Metadata Context Rules --
const MetadataContextRules = fromJS({
  optional: {
  },
  required: {
  }
});

// -- Legacy Name Export --
export const PublicQuestion = PublicQuestionModelV1;
